module.exports = __webpack_public_path__ + "img/Account.b8404979.svg";